import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getClientInfo, updateClientInfo } from "../slice/clientPanelInfoSlice";

const ClientInfo = () => {
  const dispatch = useDispatch();
  const { clientsInfo: client, loading } = useSelector((state) => state.clientInfo);
  const [displayImage, setDisplayImage] = useState(null);
  const [originalProfileImage, setOriginalProfileImage] = useState(null);
  const fileInputRef = useRef(null);

  const clientToken = localStorage.getItem("client_access_token");

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    birthdate: "",
    parent_name: "",
    phone: "",
    email: "",
    address: "",
    about: "",
  });

  useEffect(() => {
    dispatch(getClientInfo(clientToken));
  }, [dispatch]);

  useEffect(() => {
    if (client) {
      setFormData({
        first_name: client.first_name || "",
        last_name: client.last_name || "",
        birthdate: client.birthdate || "",
        parent_name: client.parent_name || "",
        phone: client.phone || "",
        email: client.email || "",
        address: client.address || "",
        about: client.about || "",
      });

      setOriginalProfileImage(client.profile_image || null);

      setDisplayImage(client.profile_image || null);
    }
  }, [client]);

  // console.log("client", client);
    
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === 'profile_image') {
      // If the user selects a new file, update formData and leave the displayImage unchanged
      setFormData((prev) => ({
        ...prev,
        profile_image: files.length > 0 ? files[0] : prev.profile_image, // Store the File object
      }));
    } else {
      // Handle other form fields
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
    
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.first_name) {
    toast.error("Child First name is required", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });
    return;
  }

  if (!formData.last_name) {
    toast.error("Child Last name is required", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });
    return;
  }

  if (!formData.birthdate) {
    toast.error("Child Birth date is required", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });
    return;
  }


    const token = localStorage.getItem("client_access_token");
    const updatedData = { ...formData };

    if (
      !updatedData.profile_image || 
      (typeof updatedData.profile_image === "string" && updatedData.profile_image === originalProfileImage)
    ) {
      delete updatedData.profile_image;
    }

    // const result = await dispatch(updateClientInfo({ token: clientToken }));
    const result = await dispatch(updateClientInfo({ formData: updatedData, token }));

    if (result.meta.requestStatus === "fulfilled") {
      toast.success("Update successful!", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
      dispatch(getClientInfo(token));
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } else {
      toast.error("Update failed", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
    }
  };

  return (
    <>
      {loading && <p>Loading...</p>}
        {/* <form onSubmit={handleSubmit}>
            <div className="row mb-3">
                <div className="col-md-3">
                    <label className="form-label">Child First Name</label>
                    <input
                        type="text"
                        name="first_name"
                        className="form-control"
                        value={formData.first_name}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Child Last Name</label>
                    <input
                        type="text"
                        name="last_name"
                        className="form-control"
                        value={formData.last_name}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Birthdate</label>
                    <input
                        type="date"
                        name="birthdate"
                        className="form-control"
                        value={formData.birthdate}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Parent Name</label>
                    <input
                        type="text"
                        name="parent_name"
                        className="form-control"
                        value={formData.parent_name}
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-md-3">
                    <label className="form-label">Password</label>
                    <input
                        type="text"
                        name="password"
                        className="form-control"
                    />
                    <small className="text-muted">Leave blank to keep the existing password.</small>
                </div>
                <div className="col-md-3">
                    <label className="form-label">Contact Number</label>
                    <input
                        type="number"
                        name="contact_number"
                        className="form-control"
                        value={formData.phone}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Email</label>
                    <input
                        type="email"
                        name="email"
                        className="form-control"
                        value={formData.email}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Profile Image</label>
                            {displayImage && typeof displayImage === 'string' && (
          <>
            <div className="mb-2">
              <img
                src={`${process.env.REACT_APP_PROFILE_IMAGE_BACKEND_URL}/${displayImage}`}
                alt="Profile"
                style={{
                  width: '100px',
                  height: '100px',
                  objectFit: 'cover',
                  borderRadius: '4px',
                }}
              />
            </div>
            <div className="mb-2 text-muted">
              Current File: <strong>{displayImage}</strong>
            </div>
          </>
        )}
                    <input
          type="file"
          name="profile_image"
          className="form-control"
          onChange={handleChange}
          ref={fileInputRef}
        />
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-md-3">
                    <label className="form-label">Address</label>
                    <input
                        type="text"
                        name="address"
                        className="form-control"
                        value={formData.address}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-6">
                    <label className="form-label">About Us</label>
                    <textarea
                        type="text"
                        name="about"
                        className="form-control"
                        value={formData.about}
                        onChange={handleChange}
                    />
                </div>
            </div>
            <button className="btn btn-primary">Update</button>
        </form> */}

        <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">My Info</h4>
          <div className="form-section mt-3">
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Child First Name</label>
                  <input
                    type="text"
                    name="first_name"
                    className="form-control"
                    value={formData.first_name}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Child Last Name</label>
                  <input
                    type="text"
                    name="last_name"
                    className="form-control"
                    value={formData.last_name}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold">Parent Name</label>
                  <input
                    type="text"
                    name="parent_name"
                    className="form-control"
                    value={formData.parent_name}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>      
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold">Contact Number</label>
                  <input
                    type="text"
                    name="phone"
                    className="form-control"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>  
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Birthdate</label>
                  <input
                    type="date"
                    name="birthdate"
                    className="form-control"
                    value={formData.birthdate}
                    onChange={handleChange}
                  />
                </div>          
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold">Address</label>
                  <input
                    type="text"
                    name="address"
                    className="form-control"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold">Profile Image</label>
                  
                  <div className="d-flex flex-column flex-md-row w-100 gap-3 align-items-start">
                    {/* Upload Field */}
                    <div className="uploadfield flex-fill">
                      <div className="custom-file-upload position-relative">
                        <button
                          type="button"
                          className="upload-btn btn btn-custom-primary position-absolute"
                          onClick={() => document.getElementById('profileImage')?.click()}
                        >
                          Upload Files
                        </button>
                        <input
                          type="file"
                          name="profile_image"
                          id="profileImage"
                          accept=".jpg,.jpeg,.png"
                          onChange={handleChange}
                          ref={fileInputRef}
                        />
                      </div>
                      <div className="file-name form-control" id="fileName">
                        {formData.profile_image?.name || "No file chosen"}
                      </div>
                      <div className="text-muted leaveblank d-block pt-1">
                        <small>
                          Supported: JPG, JPEG, PNG. Max size: 1 MB.
                        </small>
                      </div>
                    </div>

                    {/* Display Image */}
                    {displayImage && typeof displayImage === 'string' && (
                      <div className="text-md-end text-start">
                        <div className="mb-2">
                          <img
                            src={`${process.env.REACT_APP_PROFILE_IMAGE_BACKEND_URL}/${displayImage}`}
                            alt="Profile"
                            style={{
                              width: '50px',
                              height: '50px',
                              objectFit: 'cover',
                              borderRadius: '4px',
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <label className="form-label text-primary mb-1 font-weight-semibold font-size-16">Massage</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="Enter Massage"
                    value={formData.about}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12 text-center mt-4 pt-md-2">
                  <button className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1"><span className="d-block py-1">Update</span></button>
                  <button className="btn btn-danger font-weight-medium font-size-16 text-capitalize px-4 rounded m-1"><span className="d-block py-1">Cancel</span></button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientInfo;